// extracted by mini-css-extract-plugin
module.exports = {"primary-color":"#C45F24","secondary-color-a":"#917F81","secondary-color-b":"#9AA4B3","secondary-color-c":"#D89172","primary-text-color":"#493D35","background-color":"#FAFAFA"};